<template>
  <div>
    <header class="header_in clearfix">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-xl-4 noMobile" style="line-height: 50px;">
            <div id="logo">
              <a href="/" class="home">
                <i class="fas fa-home"></i>
                Home
              </a>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-xl-4 align-center">
            <div id="mainLogo logo">
              <a href="/">
                <img class="mainLogoImg" src="../../templateAssests/img/cklogo.png" width="121" height="55" alt="">
              </a>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-xl-4 align-right rightDiv noMobile" style="margin-top:10px;">
            <!-- <a href="/">
              <i class="mdi mdi-help h5"></i>
                             Help
            </a> -->
            <a href="tel:+917710999666" class="phneNo">
              <i class="mdi mdi-phone h5"></i>+91 771 099 9666
            </a>
            <br>
            <a href="mailto:enquiry@cloudkitch.co.in" class="email">
              <i class="far fa-envelope"></i>enquiry@cloudkitch.co.in
            </a>
          </div>
          <!-- /top_menu -->
          <a href="#0" class="open_close">
            <i @click="toggleMenuDrawer" class="icon_menu"></i>
            <Drawer @close="toggleMenuDrawer" align="left" :maskClosable="true" :closeable="false">
              <div v-if="openMenuDrawer">
                <section class="head_section">
                  <div v-if="userName != ''" class="row">
                    <div class="align-left">
                      <!-- <figure> -->
                      <img class="userPlaceImage" src="https://assets.cloudkitch.co.in/user_documents/avatar.jpg"
                           height="50" width="50" alt="">
                      <!-- </figure> -->
                    </div>
                    <div class="align-left">
                      <a href="/profile/my-profile" class="userName"
                         style="margin:8px 0 0 0; color:#212121; font-size:14px;">{{ userName }}</a>
                      <!-- <p class="userName userNameTextLen one-line-text" style="margin:8px 0 0 0;">{{userName}}</p> -->
                    </div>
                  </div>
                  <div v-else class="row">
                    <div class="align-left">
                      <p class="loginReg" @click="openLoginModal">Login / Register</p>
                    </div>
                  </div>
                </section>
                <hr style="margin:0px;">
                <section class="navigation_section">
                  <ul class="dropdown-ul navigation_ul align-left">
                    <a href="/">
                      <li><img src="../../templateAssests/img/ckgallery/CloudKitch_logo_solo.png"
                               style="object-fit:contain;margin-right:10px;" width="25" height="25" alt="">Home
                      </li>
                    </a>
                    <a @click="userRedirection('/checkOut')">
                      <li><img src="../../templateAssests/img/ckgallery/Cart.png" width="25" height="25"
                               style="object-fit:contain;margin-right:10px;" alt="">Cart
                      </li>
                    </a>
                    <a @click="userRedirection('/profile/my-orders')">
                      <li><i class="icon_bag_alt" style="font-size:20px;margin-right:10px;"></i>My Orders</li>
                    </a>
                    <a @click="userRedirection('/profile/my-subscriptions')">
                      <li><i class="mdi mdi-calendar-clock" style="font-size:20px;margin-right:10px;"></i>My
                        Subscriptions
                      </li>
                    </a>
                    <a @click="userRedirection('/profile/my-vouchers')">
                      <li><i class="mdi mdi-ticket-percent-outline" style="font-size:20px;margin-right:10px;"></i>Pre-Buy
                        Vouchers
                      </li>
                    </a>
                    <a @click="userRedirection('/profile/my-address')">
                      <li><i class="far fa-address-book" style="font-size:20px;margin-right:10px;"></i>My Address</li>
                    </a>
                    <a @click="userRedirection('/profile/wallet')">
                      <li><i class="mdi mdi-wallet-outline" style="font-size:20px;margin-right:10px;"></i>Wallet</li>
                    </a>
                  </ul>
                </section>
                <hr class="hrBorder">
                <!-- navigation_section -->

                <section class="help_section">
                  <h3 class="helpHead align-left">Help & Support</h3>
                  <ul class="dropdown-ul navigation_ul align-left">
                    <a href="/terms-and-conditions"><li><i class="mdi mdi-file-document-multiple-outline" style="font-size:20px;margin-right:10px;"></i>Terms & Conditions</li></a>
                    <a href="/data-privacy"><li><i class="mdi mdi-file-document-outline" style="font-size:20px;margin-right:10px;"></i>Data Privacy</li></a>
                    <!--														<a href="/policies/cookie-policy"><li><i class="mdi mdi-cookie-outline" style="font-size:20px;margin-right:10px;"></i>Cookie Policy</li></a>-->
                    <a href="/cancellations-and-refunds"><li><i class="mdi mdi-cash-refund" style="font-size:20px;margin-right:10px;"></i>Cancellations & Refunds</li></a>
                    <a href="#">
                      <li><i class="icon_mail_alt" style="font-size:20px;margin-right:10px;"></i>Contact Us</li>
                    </a>
                  </ul>
                </section>
                <hr class="hrBorder">
                <!-- help_section -->

                <section class="other_section" v-if="userName != ''">
                  <h3 class="helpHead align-left">Other</h3>
                  <ul class="dropdown-ul navigation_ul align-left">
                    <li><a @click="logout"><i class="uil uil-sign-out-alt"
                                              style="font-size:20px;margin-right:10px;"></i>Logout</a></li>
                  </ul>
                </section>
                <!-- <hr class="hrBorder"> -->
                <!-- navigation_section -->

              </div>
            </Drawer>
          </a>
        </div>
        <!-- / row -->
      </div>
      <!-- / container -->


    </header>
    <!-- /header -->
    <main>
      <div class="container">
      <b-card-text>
        <div class="section-services container">
          <h2 class="setionTitle align-center">Cancellations and Refunds</h2>
          <h4>Cancellations and Refunds</h4>
          <ul>
            <li>
              <p><b><u>Cancellation</u></b></p>
            </li>
            <li>
              <p>As a general rule you shall not be entitled to cancel your order once you have received confirmation
                of the same. If you cancel your order after it has been confirmed, CLOUDKITCH shall have a right to
                charge you cancellation fee of a minimum INR 75 upto the order value, with a right to either not to
                refund the order value or recover from your subsequent order, the complete/ deficit cancellation fee, as
                applicable, to compensate our restaurant and delivery partners. CLOUDKITCH shall also have right to
                charge you cancellation fee for the orders cancelled by CLOUDKITCH for the reasons specified under
                clause 1(iii) of this cancellation and refunds policy. In case of cancellations for the reasons
                attributable to CLOUDKITCH or its restaurant and delivery partners, CLOUDKITCH shall not charge you any
                cancellation fee.</p></li>
            <li>
              <p>
                However, in the unlikely event of an item on your order being unavailable, we will contact you on the
                phone number provided to us at the time of placing the order and inform you of such unavailability. In
                such an event you will be entitled to cancel the entire order and shall be entitled to a refund in
                accordance with our refund policy.
              </p></li>
            <li>
              <p>We reserve the sole right to cancel your order in the following circumstance:</p>
            </li>
            <li>
              <p>In the event of the designated address falls outside the delivery zone offered by us;</p>
            </li>
            <li>
              <p>Failure to contact you by phone or email at the time of confirming the order booking;</p>
            </li>
            <li>
              <p>Failure to deliver your order due to lack of information, direction or authorization from you at the
                time of delivery; or</p></li>
            <li>
              <p>Unavailability of all the items ordered by you at the time of booking the order; or</p>
            </li>
            <li>
              <p>Unavailability of all the items ordered by you at the time of booking the order; or</p>
            </li>
            <li>
              <p><b><u>Refunds</u></b></p>
            </li>
            <li>
              <p>You shall be entitled to a refund only if you pre-pay for your order at the time of placing your
                order on the Platform and only in the event of any of the following circumstances:</p>
            </li>
            <li>
              <p>Your order packaging has been tampered or damaged at the time of delivery;</p>
            </li>
            <li>
              <p>Us cancelling your order due to (A) your delivery location following outside our designated delivery
                zones; (B) failure to contact you by phone or email at the time of confirming the order booking; or (C)
                failure to contact you by phone or email at the time of confirming the order booking; or
              </p>
            </li>
            <li>
              <p>You cancelling the order at the time of confirmation due to unavailability of the items you ordered for
                at the time of booking.</p>
            </li>
            <li>
              <p>Our decision on refunds shall be at our sole discretion and shall be final and binding.</p>
            </li>
            <li>
              <p>All refund amounts shall be credited to your account within 3-4 business days from the day the refund
                request has been received, in accordance with the terms that may be stipulated by the bank which has
                issued the credit / debit card.</p>
            </li>
          </ul>
          <table class="process-table custTable table-responsive">
            <tbody><tr>
              <th>Process</th>
              <th>Payment Method</th>
              <th>Refund Source</th>
              <th>TAT</th>
            </tr>
            <tr>
              <td rowspan="10">
                <p>Order Edit/Cancellation/Compensation/Payment Failure</p>
              </td>
              <td>
                <p>Net Banking</p>
              </td>
              <td>
                <p>Source</p>
              </td>
              <td>
                <p>5-7 Business Days</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Debit/Credit Cards</p>
              </td>
              <td>
                <p>Source</p>
              </td>
              <td>
                <p>4-7 Business Days</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>UPI</p>
              </td>
              <td>
                <p>Source</p>
              </td>
              <td>
                <p>2-4 Business Days</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Amazon Pay (Wallet)</p>
              </td>
              <td>
                <p>Source</p>
              </td>
              <td>
                <p>5 Business Days</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Amazon Pay (CC/DC/NB)</p>
              </td>
              <td>
                <p>Source</p>
              </td>
              <td>
                <p>5 Business Days</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Phone Pe (Wallet)</p>
              </td>
              <td>
                <p>Source</p>
              </td>
              <td>
                <p>5 Business Days</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Phone Pe (CC/DC/NB)</p>
              </td>
              <td>
                <p>Source</p>
              </td>
              <td>
                <p>5 Business Days</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Wallets-Paytm/Mobikwik/Freecharge</p>
              </td>
              <td>
                <p>Source</p>
              </td>
              <td>
                <p>1 Hour</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Lazy Pay</p>
              </td>
              <td>
                <p>Source</p>
              </td>
              <td>
                <p>1 Hour</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Sodexo</p>
              </td>
              <td>
                <p>Source</p>
              </td>
              <td>
                <p>5 Business Days</p>
              </td>
            </tr>

            </tbody></table>
          <ul>
            <li>
              <p>In case of payment at the time of delivery, you will not be required to pay for:</p>
            </li>
            <li>
              <p>Orders where the packaging has been tampered or damaged by us;</p>
            </li>
            <li>
              <p>Wrong order being delivered; or</p>
            </li>
            <li>
              <p>Items missing from your order at the time of delivery.</p>
            </li>

          </ul>
        </div>
      </b-card-text>
      </div>
    </main>

    <loginRegModal/>
    <footerLayout/>
    <!-- footer layout -->
  </div>
</template>

<script>
import loginRegModal from "../popUpModals/loginReg";
import footerLayout from "../../layouts/footerLayout";
import Drawer from "vue-simple-drawer"
import Vue from 'vue';

export default {
  name: "cancellations-refunds",
  data() {
    return {
      policyType: '',
      openMenuDrawer: false,
    }
  },

  components: {
    footerLayout,
    loginRegModal,
    Drawer
  },
  mounted() {
    if (this.$route.params.policy) {
      this.policyType = this.$route.params.policy;
    }
    this.getUserData();

  },
  methods: {

    userRedirection(routerName) {
      if (this.userName != '') {
        if (routerName != '/checkOut') {
          window.location.href = routerName;
          return;
        }
        if (this.cartItemsDetailsHead.length > 0 && routerName == '/checkOut') {
          this.openMenuDrawer = false;
          // this.$router.push(routerName);
          window.location.href = routerName;
        } else {
          alert('No items in cart');
        }
      } else {
        this.openMenuDrawer = !this.openMenuDrawer;
        this.$bvModal.show("modal-login");
      }
    },

    getUserData() {
      this.axios.get('/getUserDeatils')
          .then((response) => {
            let status = response.status;
            if (status == 200 && response.data.status == 200) {
              if (response.data.userData.userName) {
                this.userName = response.data.userData.userName;
                this.corporateLogo = response.data.userData.corporateLogo;
              } else {
                this.userName = '';
              }
            }
          }).catch((error) => {
        console.log(error.response.data.message);
      });
    },
    toggleMenuDrawer() {
      this.openMenuDrawer = !this.openMenuDrawer
    },
    openLoginModal() {
      this.openMenuDrawer = !this.openMenuDrawer;
      this.$bvModal.show("modal-login");

    },
    logout() {
      this.$confirm("Are you sure you want to logout?", "Logout", "")
          .then(() => {
            localStorage.clear();
            Vue.prototype.$userData = '';
            Vue.prototype.$placesAddress = '';
            window.location.href = '/';
          });
    },

    pushPolicy(policyTypeTab) {
      this.$router.push('/policies/' + policyTypeTab);
    }
  }
}
</script>
<style scoped src="../../templateAssests/css/listing.css"></style>
<style scoped src="../../templateAssests/css/detail-page.css"></style>
<style>
.mainLogoImg {
  object-fit: cover;
  /* margin-left: 150px; */
}

.tabs {
  width: 100%;
}

.setionTitle {
  font-size: 30px;
  margin: 0 0 50px 0;
  color: #A4827D;
}

body {
  background: #fff !important;
}

.nav-pills {
  margin-top: 20px !important;

}

.tab-content {
  margin: 30px 0px !important;
  border-left: 1px solid #f1f1f1

}

.card-text {
  color: #A4827D;
}

.policyHead {
  margin: 35px 0;
  margin-bottom: 10px;
  color: #A4827D;
  font-size: 24px;
}

ul, li {
  text-decoration: none;
  padding-left: 0px;
}

li h4,
h4 {
  color: #A4827D;
  margin-top: 20px;
  margin-bottom: 5px;
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
  color: #000;
  background-color: #ffc60c;
}

.section-services p {
  margin-bottom: 0px;
  line-height: 30px;
  font-size: 14px;
}

.section-services a {
  color: #F3766A;
}

.custTable {
  border: 1px solid #f1f1f1;
  margin-top: 30px;
  margin-bottom: 30px;
}

.custTable tr th {
  background-color: #f1f1f1;
  text-align: left;
}

table, tr, td, th {
  border-spacing: 0;
  padding: 0;
  margin: 0;
  vertical-align: top;
}

.custTable tr th, .custTable tr td {
  padding: 15px;
  border: 1px solid #f1f1f1;
}

.process-table {
  width: 100%;
}

#logo a {
  color: #000;
}

#logo a:hover, .logo a:focus {
  color: #F3766A;
}

/* .tabsPostion{
    border-right: 1px solid #f1f1f1;
    position: sticky;
    top: 90px;
    height: 100%;
} */
header {
  position: sticky !important;
}

.rightDiv a {
  color: #000;
}

.rightDiv a:hover, .rightDiv a:focus {
  color: #F3766A;
}

.rightDiv a i {
  margin-left: 5px;
  margin-right: 3px;
}

.home {
  font-family: 'GothamMedium' !important;
  font-size: 16px;
  color: #212121;
}

a.phneNo, a.email {
  font-size: 14px;
  color: #212121;
}

@media (min-width: 575px) {
  .tabsPostion {
    /* border-right: 1px solid #f1f1f1; */
    position: sticky;
    top: 90px;
    height: 100%;
    padding-left: 20px;
  }
}

.userPlaceImage {
  object-fit: contain;
  border-radius: 25px;
}

.loginReg {
  font-size: 18px;
  color: #F3766A;
}

.head_section {
  margin-bottom: 20px;
}

.navigation_ul li {
  padding: 12px 0;
  font-size: 14px;
}

.navigation_ul a li {
  color: #777;
}

.helpHead {
  font-size: 16px;
  color: #777;
}
</style>